import gql from 'graphql-tag';

export const LINK_NEW_PARTNER = gql`
  mutation LinkNewPartner($input: LinkNewPartnerInput!) {
    linkNewPartner(input: $input) {
      partnerLinkDynamicsId
    }
  }
`;
